import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';

export type SetRequestActiveDialogData = Record<string, never>;
export interface SetRequestActiveDialogResult {
    confirmed: true;
}

@Component({
    selector: 'app-set-request-active-dialog',
    templateUrl: './set-request-active-dialog.component.html',
    imports: [TranslateModule, RouterModule, DialogWrapperComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SetRequestActiveDialog {
    private readonly dialogRef = inject<MatDialogRef<SetRequestActiveDialog>>(MatDialogRef);
    public data = inject<SetRequestActiveDialogData>(MAT_DIALOG_DATA);

    public close(): void {
        this.dialogRef.close();
    }

    public confirm(): void {
        this.dialogRef.close({ confirmed: true } satisfies SetRequestActiveDialogResult);
    }
}
